export default function Register({ onSubmit }) {

    return (
        <button className="btn btnRes btnHover btnConfirm btnRadius btnWidthMedium textBoldHight"  onClick={() => onSubmit("register")}>
            สมัครสมาชิก
        </button>
    );
}